<template>
  <el-container>
    <el-aside :width="showChild ? '320px' : '200px'">
      <el-card class="box-card" shadow="never">
        <!-- <div slot="header">
          <span>商品类别</span>
        </div> -->
        <el-cascader-panel
          v-model="cascaderSelect"
          :options="cascaderData"
          @expand-change="handleExpandChange"
          @change="handleChange"
        >
          <template slot-scope="{ data }">
            <span>{{ data.text }}</span>
          </template>
        </el-cascader-panel>
      </el-card>
    </el-aside>
    <el-main>
      <el-card class="main-box-card" shadow="never">
        <!-- <div slot="header">
          <span>选择商品(可多选)</span>
        </div> -->
        <template>
          <el-card class="main-header-card" shadow="never">
            <el-form :inline="true" @submit.native.prevent="queryProduct">
              <el-form-item>
                <el-input
                  placeholder="支持助记码查询"
                  v-model="productArgs.keyWords"
                  clearable
                >
                  <template slot="prepend">查询条件</template>
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="queryProduct"
                  ></el-button>
                </el-input>
              </el-form-item>
              <el-form-item style="float: right">
                <div>
                  <span style="margin-right: 16px; color: #f56c6c"
                    >已选：{{ selectProductList.length }}条</span
                  >
                  <el-button type="success" @click="postProductMessage"
                    >确定</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
          </el-card>
          <div class="table">
            <el-table
              ref="table"
              :row-key="getRowKey"
              v-loading="tableIsLoading"
              :data="productList"
              border
              stripe
              height="100%"
              max-height="100%"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="index" width="50"></el-table-column>
              <el-table-column
                type="selection"
                width="50"
                reserve-selection
                :selectable="selectable"
              ></el-table-column>
              <el-table-column label="商品名称" prop="text"></el-table-column>
              <el-table-column label="规格" prop="itemSpec"></el-table-column>
              <el-table-column v-if="args.tag == 'PKD'" label="库存数" prop="onhandQtyQtyFormat"></el-table-column>
              <el-table-column v-if="args.tag == 'PKD'" label="可用数" prop="availableQtyFormat"></el-table-column>
              <el-table-column v-if="args.tag == 'PKD' && $store.state.power.isEnableProductDate == 'Y'" label="生产日期" prop="productionDate"></el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="productArgs.page"
            :page-sizes="[10, 20, 100]"
            :page-size="productArgs.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="productTotal"
          >
          </el-pagination>
          <template>
            <div class="product_footer">
              <span class="product_label">已选商品:</span>
              <div>
                <span
                  class="product_text"
                  v-for="(item, index) in selectProductList"
                  :key="index"
                  >{{ index ? "," + item.text : item.text }}</span
                >
              </div>
            </div>
          </template>
        </template>
      </el-card>
    </el-main>
  </el-container>
</template>

<script>
export default {
  props: {
    args: {
      type: Object,
      default: () => { return {} }
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    },
    defaultDisabledKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      brandArgs: {
        url: "/Account/dataSearch/selectBrandListForVue.html",
      },
      brandTypeArgs: {
        url: "/Account/dataSearch/selectTypeListForVue.html",
        brandID: "",
        isPage: 'N'
      },
      productArgs: {
        page: 1,
        size: 10,
        brandID: "",
        itemTypeID: "",
        keyWords: "",
        url: "/Account/itemMasterDefine/selectItemMastForVue.html",
      },
      cascaderSelect: ["", ""],
      cascaderData: [],
      tableIsLoading: false,
      productList: [],
      productTotal: 0,
      selectProductList: [],
      showChild: true,
    };
  },
  created() {
    let _arr = window.location.href.split("?");
    if (_arr.length > 1) {
      if (_arr[1].indexOf("showChild=1") != -1) {
        this.showChild = false;
      } else {
        this.showChild = true;
      }
    } else {
      this.showChild = true;
    }
    if (this.args?.isFitterEnabled) {
      this.productArgs['isFitterEnabled'] = this.args?.isFitterEnabled
    }
    this.getBrandData();
    this.getProductData();
    this.toggleRowSelection()
  },
  methods: {
    async getBrandData() {
      if (this.showChild) {
        this.brandArgs.url = "/Account/dataSearch/selectBrandListForVue.html";
        this.brandArgs.isPage = "N";
      } else {
        this.brandArgs.url =
          "/Account/shanhaoReport/selectBrandListForVue.html";
        this.brandArgs.page = 1;
        this.brandArgs.size = 10;
        this.brandArgs.isPage = "N";
      }
      const { data: res } = await this.$http.post(this.brandArgs.url, this.Qs.stringify(this.brandArgs))
      if (res.code != "success") return this.$message.error(res.message);
      res.result = JSON.parse(res.result);
      let arr = JSON.parse(res.result.data);
      this.cascaderData = [];
      arr.map((item) => {
        let _obj = {
          text: item.text,
          value: item.value,
        };
        if (this.showChild) {
          _obj.children = [
            {
              value: "",
              text: "全部",
            },
          ];
        }
        this.cascaderData.push(_obj);
      });
      if (this.showChild) {
        this.cascaderData.unshift({
          value: "",
          text: "全部",
          children: [
            {
              value: "",
              text: "全部",
            },
          ],
        });
      } else {
        this.cascaderData.unshift({
          value: "",
          text: "全部",
        });
      }
    },
    async getBrandTypeData(brand) {
      if (!brand) return false;
      const { data: res } = await this.$http.post(this.brandTypeArgs.url, this.Qs.stringify(this.brandTypeArgs));
      if (res.code != "success") return false;
      res.result = JSON.parse(res.result);
      this.cascaderData.some((item, index) => {
        if (item.value == brand) {
          this.cascaderData[index].children = JSON.parse(res.result.data);
          this.cascaderData[index].children.unshift({
            value: "",
            text: "全部",
          });
          return true;
        }
      });
    },
    async getProductData() {
      this.productArgs.brandID = this.cascaderSelect[0];
      if (!this.showChild) {
        this.productArgs.url =
          "/Account/shanhaoReport/selectItemMastForVue.html";
        delete this.productArgs.itemTypeID;
      } else {
        this.productArgs.url =
          "/Account/itemMasterDefine/selectItemMastForVue.html";
        this.productArgs.itemTypeID = this.cascaderSelect[1];
      }
      if (this?.args?.tag == 'PKD') {
        this.productArgs.url = "/Account/dataSearchVue/selectItemEnterDetailList.html";
        this.productArgs.firstValue = this.productArgs.brandID
        this.productArgs.secondValue = this.productArgs.itemTypeID
        this.productArgs.searchType = ''
        this.productArgs.billType = 'PKD'
        this.productArgs.warehouseID = this?.args?.warehouseID
      }
      this.tableIsLoading = true;
      const { data: res } = await this.$http.post(this.productArgs.url, this.Qs.stringify(this.productArgs))
      this.tableIsLoading = false;
      if (res.code != "success") return this.$message.error(res.message);
      res.result = JSON.parse(res.result);
      if (this?.args?.tag == 'PKD') {
        this.productList = JSON.parse(res.result.data).map(i => {
          i['text'] = i.itemName
          i['value'] = i.itemID
          return i
        });
      } else {
        this.productList = JSON.parse(res.result.data);
      }
      this.productTotal = res.result.total;
    },
    handleExpandChange(value) {
      this.$set(this.cascaderSelect, 0, value[0]);
      this.$set(this.cascaderSelect, 1, "");
      this.brandTypeArgs.brandID = value[0];
      if (this.showChild) {
        this.getBrandTypeData(value[0]);
      }
      this.productArgs.page = 1;
      this.getProductData();
    },
    handleChange(value) {
      this.cascaderSelect = value;
      this.productArgs.page = 1;
      this.getProductData();
    },
    handleSelectionChange(val) {
      this.selectProductList = val;
    },
    // 监听pagesize的改变
    handleSizeChange(newSize) {
      this.productArgs.size = newSize;
      this.getProductData();
    },
    // 监听页码值的改变
    handleCurrentChange(newPage) {
      this.productArgs.page = newPage;
      this.getProductData();
    },
    getRowKey(row) {
      return row.value + row.productionDate;
    },
    queryProduct() {
      this.productArgs.page = 1;
      this.getProductData();
    },
    postProductMessage() {
      this.$emit('get-product-data', this.selectProductList)
    },
    toggleRowSelection() {
      this.defaultCheckedKeys.forEach(item => {
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(item, true)
        })
      })
    },
    selectable (row) {
      return this.defaultDisabledKeys.findIndex(i => i.value + i.productionDate == row.value + row.productionDate) == -1
    }
  },
};
</script>

<style scoped lang="less">
.el-container {
  height: 100vh;
  max-height: 800px;
  ::v-deep .box-card,
  ::v-deep .main-box-card {
    height: calc(100% - 2px);
  }
  ::v-deep .box-card .el-card__header,
  ::v-deep .main-box-card > .el-card__header {
    padding: 10px 20px;
  }
  ::v-deep .box-card .el-card__body,
  ::v-deep .main-box-card > .el-card__body {
    height: 100%;
  }
  .el-aside {
    height: 100%;
    ::v-deep .box-card {
      .el-card__body {
        padding: 0;
        .el-cascader-panel {
          width: 100%;
          height: 100%;
          display: flex;
          border: none;
          .el-cascader-menu {
            flex: 1;
            min-width: 0;
            .el-cascader-menu__wrap {
              height: 100%;
              overflow-x: hidden;
            }
          }
        }
      }
    }
  }
  .el-main {
    padding: 0 20px;
    ::v-deep .main-box-card {
      min-width: 600px;
      border: none;
      & > .el-card__body {
        padding: 0 12px;
      }
      .main-header-card {
        border: none;
        .el-card__body {
          padding: 12px 0;
          .el-form-item {
            margin-bottom: 0;
          }
        }
      }
      .table {
        width: 100%;
        height: calc(100% - 64px - 32px - 62px);
      }
      .table .el-table td,
      .table .el-table th {
        padding: 6px 0;
      }
      .product_footer {
        display: flex;
        margin-top: 12px;
      }
      .product_label {
        width: 100px;
      }
      .product_footer > div {
        width: calc(100% - 100px);
        height: 50px;
        overflow: auto;
      }
      .product_text {
        padding: 0 2px;
      }
    }
  }
}
</style>